import { render, staticRenderFns } from "./MyChoirSummaryBox.vue?vue&type=template&id=7e012c30&scoped=true&"
import script from "./MyChoirSummaryBox.vue?vue&type=script&lang=ts&"
export * from "./MyChoirSummaryBox.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e012c30",
  null
  
)

export default component.exports